module.exports = "/_next/static/images/suggestPopUp-30980e7c89814ee81ace04b743f7b7b4.svg";